import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttpRequests from "../../hooks/useHttpRequests";
import { environment } from "../../environments/environment";

const Login = () => {
  const navigate = useNavigate();
  const [errs, setErrs] = useState(false);
  const { sendRequest: fetchUser } = useHttpRequests();
  const handleLogin = () => {
    setErrs(false);

    const getUserResponse = (userObj) => {
      if (!userObj || !userObj.isSuccess || userObj.errorResponse) {
        setErrs(true);
        console.log("user fetch response returns error");
        return;
      }
      localStorage.setItem("currentUser", JSON.stringify(userObj));
      const userData = { isAuthenticated: true };
      navigate("/home", { state: userData });
    };

    var searchString = window.location.search.substring(1);
    var pos = searchString.indexOf("=");

    var code = searchString.substring(pos + 1);

    const fetchAuthUser = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const encodedAccessToken = encodeURIComponent(accessToken);
        const response = await fetch(
          `${environment.getSSO("user")}${encodedAccessToken}`
        );

        if (response.ok) {
          const data = await response.json();
          localStorage.setItem("currentSsoUser", data.id);
          fetchUser(
            {
              url: "Account/authenticate",
              body: {
                userName:
                  environment.userDomain +
                  localStorage.getItem("currentSsoUser"),
              },
            },
            getUserResponse
          );
        } else {
          console.log(
            "FetchAuthuser request failed with status " + response.status
          );
        }
      } catch (error) {
        console.log("Error fetching FetchAuthuser data: " + error.message);
      }
      return false;
    };

    const fetchAuth = async () => {
      try {
        const response = await fetch(`${environment.getSSO("token")}${code}`);

        if (response.ok) {
          const json = await response.json();
          const accessToken = json.access_token;
          const encodedAccessToken = encodeURIComponent(accessToken);

          localStorage.setItem("accessToken", encodedAccessToken);
          return fetchAuthUser();
        } else {
          console.log(
            "fetchAuth request failed with status " + response.status
          );
          navigate("/");
        }
      } catch (error) {
        console.log("Error fetching fetch auth data: " + error.message);
      }
      return false;
    };

    if (code === "") {
      window.location.href = environment.getSSO("href");
    } else {
      return fetchAuth();
    }
  };

  useEffect(() => {
    handleLogin();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <h2>Please wait...</h2>
      <br />
      {/* <button onClick={handleLogin}>Login</button> */}
      <br />
      {errs && (
        <h2 style={{ color: "red" }}>
          "UserID" is not set up for TeamFlow. Access requests for TeamFlow can
          be submitted through MyAccess.
        </h2>
      )}
    </div>
  );
};

export default Login;
